import { render, staticRenderFns } from "./ConfigurationArtTeam.vue?vue&type=template&id=5ce39e57&scoped=true"
import script from "./ConfigurationArtTeam.vue?vue&type=script&lang=js"
export * from "./ConfigurationArtTeam.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationArtTeam.vue?vue&type=style&index=0&id=5ce39e57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce39e57",
  null
  
)

export default component.exports